import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { ModalMessage } from './ModalMessage'; // Importamos el ModalMessage

export default function AutocompleteFinder({ optionList, arrayData }) {
  const [selectedData, setSelectedData] = useState(null); // Estado para el dato seleccionado

  const handleSelect = (event, value) => {
    const index = optionList.findIndex((option) => option === value);
    if (arrayData) {
      const dataObject = arrayData[index];
      setSelectedData(dataObject); // Establecemos el objeto seleccionado en el estado
    }
  };

  return (
    <div style={{ width: '100%' }}>
      <Autocomplete
        freeSolo
        id="free-solo-2-demo"
        disableClearable
        options={optionList}
        onChange={handleSelect}
        renderInput={(params) => (
          <TextField
            {...params}
            label="ASIGNATURA"
            InputProps={{
              ...params.InputProps,
              type: 'search',
            }}
          />
        )}
      />
      {selectedData && <ModalMessage dataObject={selectedData} setOpen={setSelectedData} />}
    </div>
  );
}
